<label class="label-fw">
  Sezioni
  <a class="btn btn-lg" (click)="clickButtonCreateItem()">
    <i class="fas fa-plus"></i>
  </a>
</label>
<div class="table-responsive-sm w-100 dataTables_wrapper">
  <table aria-describedby=""  class="table  " style="width: 100%;">
    <thead>
      <tr class="back-white fw-bold">
        <th class="pb-4 border-bottom-0" scope="col"></th>
        <th class="pb-4 border-bottom-0" scope="col">#</th>
        <th class="pb-4 border-bottom-0" scope="col">Titolo</th>
        <th class="pb-4 border-bottom-0" scope="col">Pubblicato</th>
        <th class="pb-4 border-bottom-0" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-font grabbable" [ngClass]="{'active-row':rowClickActive === true}"
        *ngFor="let obj of inputMenuItems; let i = index" draggable="true" (mousedown)="rowClickMouseDown($event)"
        (mouseup)="rowClickMouseUp($event)" (dragover)="allowDrop($event,i)" (dragstart)="onDragStart(i)"
        (drop)="onDrop($event, i)">
        <td class="row-grabbable grip">
          <i class="fas fa-grip-vertical"></i>
        </td>
        <td>{{obj.index}}</td>
        <td>{{obj.listTitle}}</td>
        <td>
          <i *ngIf="obj.published" class="fas fa-circle grn"></i>
          <i *ngIf="!obj.published" class="fas fa-circle red"></i>
        </td>
        <td style="text-align-last: end;">
          <div class="btn-group" role="group" aria-label="azioni">
            <button title="Decrementa posizione" class="btn btn-md" (click)="clickButtonMoveUpItem(obj.id)">
              <i class="fas fa-arrow-up"></i>
            </button>
            <button title="Incrementa posizione" class="btn btn-md" (click)="clickButtonMoveDownItem(obj.id)">
              <i class="fas fa-arrow-down"></i>
            </button>
            <a title="Pubblica" [hidden]="obj.published" class="btn btn-lg pr-0"
                (click)="clickButtonPublishedItem(obj,true)"><i class="fas fa-eye"></i></a>
            <a title="Depubblica" [hidden]="!obj.published" class="btn btn-lg pr-0"
                (click)="clickButtonPublishedItem(obj,false)"><i class="fas fa-eye-slash"></i></a>
            <a title="Modifica" class="btn btn-lg pr-5" (click)="clickButtonUpdateItem(obj.id)"><i class="far fa-pencil ora"></i></a>
            <a title="Cancella" class="btn btn-lg pl-0" (click)="clickButtonDeleteItem(obj.id)"><i class="far fa-trash-alt red"></i></a> 
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>